module.exports = __webpack_public_path__ + "img/pokeball.354eb285.svg";